import MailNotification from "./Tabs/Mail/MailNotification";
import PrtgNotification from "./Tabs/Prtg/PrtgNotification";
import SocialNotification from "./Tabs/Social/SocialNotification";
import SyslogNotification from "./Tabs/Syslog/SyslogNotification";

const NotificationsBody = ({ selectedNotification }) => {
  return (
    <div className="notifications-body">
      {selectedNotification === "Mail" ? (
        <MailNotification selectedNotification={selectedNotification} />
      ) : selectedNotification === "Syslog" ? (
        <SyslogNotification selectedNotification={selectedNotification} />
      ) : selectedNotification === "Prtg" ? (
        <PrtgNotification selectedNotification={selectedNotification} />
      ) : selectedNotification === "Social" ? (
        <SocialNotification selectedNotification={selectedNotification} />
      ) : null}
    </div>
  );
};

export default NotificationsBody;
